<template>
<div class="star-rating">
    <div class="star-container">
        <div class="star-container-inner">
            <div class="star-icon grey" v-html="starIcons"></div>
            <div class="star-icon orange" v-bind:style="getCssWidth" v-html="starIcons"></div>
        </div>
    </div>
    <span class="indicator review-count">({{ reviewCount }})</span>
</div>
</template>

<script>
export default {
  name: "StarRating",
  props: {
    reviewRating: {
      type: Number,
      default: 0
    },
    reviewCount: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      starIcons: `&#9733;&#9733;&#9733;&#9733;&#9733;`
    };
  },
  directives: {},
  computed: {
    getCssWidth() {
      let styles = {
        'width': `${this.toPercentage(this.reviewRating)}`
      }
      return styles;
    }
  },
  methods: {
    toPercentage(num) {
      return `${num / 5 * 100}%`;
    }
  }
};
</script>

<style scoped lang="scss">
.star-rating {
  height: 30px;
  display: flex;
  align-items: center;
  font-size: 20px;
  line-height: 1em;
  .star-container {
    &:before, &:after {
      content: " "!important;
      display: table!important;
    }
  }
  .star-container-inner {
    font-family: 'Times New Roman';
    margin-top: 5px;
    .star-icon {
      font-size: 16px;
      height: 20px;
      font-family: 'Times New Roman'!important;
      position: relative!important;
      display: block!important;
      overflow: hidden!important;
      &.orange {
        color: $primary;
        bottom: 20px;
      }
      &.grey {
        color: $grey;
      }
    }
  }
  .star-container:not(:last-child) {
    margin-right: 5px;
  }
  .review-count {
    color: $black;
    margin-bottom: 14px;
    line-height: 28px;
    font-size: 12px;
    font-family: "STIHL Contraface Text";
    font-weight: 700;
  }
}

</style>